import { baseApi } from "./baseApi";

const TASK_BASE_URL = "/tasks";

export const taskApi = baseApi.injectEndpoints({
  tagTypes: ["Task"],

  endpoints: (builder) => ({
    getTaskList: builder.query({
      query: (params) => ({ url: `${TASK_BASE_URL}`, params }),
      providesTags: (result) =>
        result
          ? [
              ...result?.data?.map(({ _id }) => ({ type: "Task", _id })),
              { type: "Task", id: "LIST" },
            ]
          : [{ type: "Task", id: "LIST" }],
    }),

    getTaskDetail: builder.query({
      query: (id) => `${TASK_BASE_URL}/${id}`,
      providesTags: (result, error, id) => [
        { type: "Task", id },
        { type: "Task", id: "LIST" },
      ],
    }),

    createTask: builder.mutation({
      query: (payload) => ({
        url: `${TASK_BASE_URL}`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: (result, error, { _id }) => [
        { type: "Task", id: "LIST" },
      ],
    }),

    updateTask: builder.mutation({
      query: (payload) => {
        const { _id, ...body } = payload;

        return {
          url: `${TASK_BASE_URL}/${_id}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: (result, error, { _id }) => [
        { type: "Task", _id },
        { type: "Task", id: "LIST" },
      ],
    }),

    addResponseToTask: builder.mutation({
      query: (payload) => {
        const { _id, ...body } = payload;

        return {
          url: `${TASK_BASE_URL}/${_id}/responses`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: (result, error, { _id }) => [
        { type: "Task", _id },
        { type: "Task", id: "LIST" },
      ],
    }),

    getTaskByAssignee: builder.query({
      query: (assignee) => `${TASK_BASE_URL}/assignees/${assignee}`,
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ _id }) => ({ type: "Task", _id })),
              { type: "Task", id: "LIST" },
            ]
          : [{ type: "Task", id: "LIST" }],
    }),
  }),
});

export const {
  useGetTaskListQuery,
  useLazyGetTaskListQuery,
  useGetTaskDetailQuery,
  useCreateTaskMutation,
  useUpdateTaskMutation,
  useAddResponseToTaskMutation,
  useGetTaskByAssigneeQuery,
} = taskApi;
